/* CØRT TV — Page JavaScript */
(function () {
  'use strict';

  /* ── Scroll Reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Pipeline step reveal ── */
  function initPipeline() {
    var steps = document.querySelectorAll('.cort-pipeline__step');
    if (!steps.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.3 });
    steps.forEach(function (s) { io.observe(s); });
  }

  /* ── Score count-up ── */
  function countUp(el, target, duration) {
    var start = 0;
    var step = target / (duration / 16);
    var current = start;
    var timer = setInterval(function () {
      current += step;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      el.textContent = Math.round(current);
    }, 16);
  }

  function initScores() {
    var scores = document.querySelectorAll('[data-count-to]');
    if (!scores.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var target = parseInt(e.target.getAttribute('data-count-to'), 10);
          countUp(e.target, target, 1200);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    scores.forEach(function (el) { io.observe(el); });
  }

  /* ── Live clock ── */
  function initClock() {
    var clock = document.querySelector('.cort-live-mock__clock');
    if (!clock) return;
    var secs = 0;
    var timer = setInterval(function () {
      secs++;
      var m = Math.floor(secs / 60);
      var s = secs % 60;
      clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }, 1000);
    // stop after 2 hours to avoid memory leaks
    setTimeout(function () { clearInterval(timer); }, 7200000);
  }

  /* ── Init ── */
  function init() {
    document.documentElement.classList.add('cort-anim');
    initReveal();
    initPipeline();
    initScores();
    initClock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
